export const APP_CONFIG = 'appConfig';
export const DEFAULT = 'default';
export const LOCAL_ENV = 'LOCAL_ENV';
export const LOCAL = 'local';
export const PROD_ENVS = ['prod', 'production'];
export const ENV_REPLACER = '{ENV}';
